<body class="body popup-loader counter-scroll">
  <div id="wrapper">

    <div class="page-title">
      <div class="tf-tsparticles">
        <div id="tsparticles1" data-color="#fff" data-line="#fff"></div>
      </div>
      <div class="tf-container">
        <div class="row">
          <div class="col-12">
            <div class="content">
              <h1 class="title">My Profile</h1>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="main-content-dashboard-wrap">
    <div class="main-content-dashboard gap62">

      <!-- my account profile -->
      <div class="my-account-profile">
        <div class="tf-container">
          <div class="row">
            <div class="col-lg-12">
              <div class="profile-infor">
                <div class="edit-infor">

                  <form class="form-infor" id="form-infor" [formGroup]="changeEmailAddressForm">
                    <div class="cols mb-30 has-verified">
                      <fieldset>
                        <label for="changeEmailAddress">Email address</label>
                        <input type="email" id="changeEmailAddress" formControlName="changeEmailAddress"
                          placeholder="Enter new email address">
                        <div *ngIf="changeEmailAddressForm.get('changeEmailAddress')?.errors?.['email']"
                          class="invalid-feedback">
                          Invalid email format
                        </div>
                      </fieldset>
                      <div class="verified done">
                        <i class="icon-check-1"></i>
                        <p class="text fs-14">
                          Email verified
                        </p>
                      </div>
                    </div>
                  </form>

                </div>

                <div class="heading-left" style="justify-content: center;">
                  <h4 class="title fw-9 mb-6" data-wow-delay="0s">
                    Change Email
                  </h4>
                  <p class="sub-title fw-4 type-secondary mb-30">
                    Here you can change your contact's informations
                  </p>
                  <button type="button" [disabled]="!isEmailFormValid" class="tf-btn pd-0-46" [ngClass]="{
                              'style-1': isEmailFormValid,
                              'style-3': !isEmailFormValid
                          }" (click)="onSubmitChangeEmail()">
                    Save
                  </button>
                </div>

              </div>
            </div>

            <!-- CHANGE PASSWORD  START -->
            <div class="profile-infor">
              <div class="col-lg-12">
                <div class="profile-security">
                  <div class="edit-password">
                    <form id="form-security-change-psw" class="form-security" [formGroup]="changePasswordForm">

                      <div class="cols mb-30 relative has-verified z-5">
                        <fieldset>
                          <label for="pass2">Current Password</label>
                          <input class="password p-10-19" id="pass0"
                            [type]="isCurrentPasswordVisible ? 'text' : 'password'" placeholder="Password"
                            formControlName="currentPassword">
                          <span class="toggle-password first-time" (click)="toggleCurrentPasswordVisibility()"
                            (keydown)="toggleCurrentPasswordVisibility()" tabindex="0" role="button">
                            <i class="icon-view"></i>
                          </span>
                        </fieldset>
                      </div>

                      <div class="cols mb-30 relative has-verified z-5">
                        <fieldset>
                          <label for="pass2">New Password</label>
                          <input class="password p-10-19" id="pass2" [type]="isPasswordVisible ? 'text' : 'password'"
                            placeholder="Password" formControlName="newPassword">
                          <span class="toggle-password first-time" (click)="toggleNewPasswordVisibility()"
                            (keydown)="toggleNewPasswordVisibility()" tabindex="0" role="button">
                            <i class="icon-view"></i>
                          </span>
                        </fieldset>
                      </div>

                      <div class="cols relative has-verified z-5">
                        <fieldset>
                          <label for="confirmPass2">Confirm New Password</label>
                          <input class="password p-10-20" id="confirmPass2"
                            [type]="isConfirmPasswordVisible ? 'text' : 'password'" required placeholder="Password"
                            formControlName="confirmPassword">
                          <span class="toggle-password second-time" (click)="toggleConfirmPasswordVisibility()"
                            (keydown)="toggleConfirmPasswordVisibility()" tabindex="0" role="button">
                            <i class="icon-view"></i>
                          </span>
                        </fieldset>
                      </div>

                    </form>
                  </div>

                  <div class="heading-left" style="justify-content: center;">
                    <h4 class="title fw-9 mb-6" data-wow-delay="0s">
                      Change Password
                    </h4>
                    <p class="sub-title fw-4 type-secondary mb-30">
                      Here you can change the password
                    </p>
                    <button type="button" form="form-security-change-psw"
                      [ngClass]="{ 'style-1': changePasswordForm.valid, 'style-3': !changePasswordForm.valid }"
                      [disabled]="!changePasswordForm.valid" class="tf-btn pd-0-46" (click)="onSubmitChangePassword()">
                      Save
                    </button>
                  </div>

                </div>
              </div>
            </div>
            <!-- CHANGE PASSWORD END-->

            <!-- CHANGE Wallet  START -->
            <div class="profile-infor">
              <div class="col-lg-12">
                <div class="profile-security">

                  <div class="edit-password">
                    <form id="form-security-edit-wallet" class="form-security" [formGroup]="changeWalletForm">
                      <!-- INB Wallet Input -->
                      <div class="cols mb-30 relative has-verified z-5">
                        <fieldset>
                          <label for="inbWallet">Web3 Wallet Address from your payment will come</label>
                          <input class="password p-10-19" type="text" id="inbWallet" formControlName="inbWallet"
                            placeholder="Enter Inbound wallet address">
                          <div *ngIf="changeWalletForm.get('inbWallet')?.errors?.['required']" class="invalid-feedback">
                            Field is required
                          </div>
                        </fieldset>
                      </div>

                      <!-- OUT Wallet Input -->
                      <div class="cols relative has-verified z-5">
                        <fieldset>
                          <label for="outWallet">Web3 Wallet Address where you'll receive your prizes</label>
                          <input class="password p-10-19" type="text" id="outWallet" formControlName="outWallet"
                            placeholder="Enter Outbound wallet address">
                          <div *ngIf="changeWalletForm.get('outWallet')?.errors?.['required']" class="invalid-feedback">
                            Field is required
                          </div>
                        </fieldset>
                      </div>
                    </form>
                  </div>

                  <div class="heading-left" style="justify-content: center;">
                    <h4 class="title fw-9 mb-6" data-wow-delay="0s">
                      Change Wallet
                    </h4>
                    <p class="sub-title fw-4 type-secondary mb-30">
                      Here you can change the wallet's addresses
                    </p>

                    <button type="button" [disabled]="!isWalletFormValid" class="tf-btn pd-0-46" [ngClass]="{
                              'style-1': changeWalletForm.valid && changeWalletForm.dirty,
                              'style-3': !changeWalletForm.valid || !changeWalletForm.dirty}"
                      (click)="onSubmitChangeWallet()">
                      Save
                    </button>

                  </div>

                </div>
              </div>
            </div>
            <!-- CHANGE Wallet END-->

            <!-- CHANGE IBAN  START -->
            <div class="profile-infor">
              <div class="col-lg-12">
                <div class="profile-security">

                  <div class="edit-password">
                    <form id="form-security-edit-iban" class="form-security" [formGroup]="changeIbanForm">
                      <div class="cols mb-30 relative has-verified z-5">
                        <fieldset>
                          <label for="iban">IBAN to receive your prizes</label>
                          <input class="iban-input" type="text" [value]="iban"
                            [placeholder]="changeIbanForm.value.ibanCode || ''" formControlName="ibanCode">

                          <span class="toggle-password first-time"></span>
                        </fieldset>
                        <div
                          *ngIf="changeWalletForm.hasError('ibanMismatch') && (changeWalletForm.dirty || changeWalletForm.touched)">
                          <p>The code is not a valid IBAN code.</p>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div class="heading-left">
                    <h4 class="title fw-9 mb-6" data-wow-delay="0s">
                      Change IBAN
                    </h4>
                    <p class="sub-title fw-4 type-secondary mb-30">
                      Here you can change your IBAN
                    </p>
                    <button type="submit" form="form-security-edit-iban"
                      [ngClass]="{ 'style-1': changeIbanForm.valid, 'style-3': !changeIbanForm.valid }"
                      [disabled]="!changeIbanForm.valid" class="tf-btn pd-0-46" (click)="onSubmitChangeIban()">
                      Save
                    </button>
                  </div>

                </div>
              </div>
            </div>
            <!-- CHANGE IBAN END-->

            <app-lottery-results *ngIf="results && results.length" [title]="'Your Recent Ticket'" [results]="results"
              [columns]="[
                          { header: 'Your Ticket', field: 'yourTicket' },
                          { header: 'Your Votes', field: 'yourVotes' },
                          { header: 'Voted Ticket', field: 'votedTicket' },
                          { header: 'Voted Votes', field: 'votedVotes' }
                        ]" [pagination]="pagination" (pageChange)="onPageChange($event)"></app-lottery-results>
          </div>
        </div>
      </div>
      <!-- /my account profile -->


    </div>
    <!-- /main-content -->
  </div>
  <!-- /main-content -->



  <!-- /wrapper
  <app-compact-menu></app-compact-menu>-->
</body>